var _excluded = ["color", "spacing", "backgroundImage", "id", "hasSeparator", "hasOverflowHidden", "isFillingRemainingSpace", "hasFullscreenBackground", "hasHorizontalGradient", "otherSectionRefs", "customColor", "zIndex", "isFullViewportHeight", "viewportHeightOffsetUnit", "isContentVerticalCenter", "link", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useInView } from "react-intersection-observer";
import OnColorContext from "../../../contexts/OnColorContext";
import SectionSpacingValueSpaceContext from "../../../contexts/SectionSpacingValueSpaceContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { headerHeight } from "../../../settings";
import { CustomTextColor, getCustomColor } from "../../../utils/getCustomColor";
import throwError from "../../../utils/throwError";
import { defaultProps } from "./SectionOrg.props";
import { backgrounds, spacingSpace } from "./SectionOrg.settings";
import { FullscreenBackground, SectionLink, StyledSectionOrg } from "./SectionOrg.styled";
function SectionOrg(_ref) {
  var _entry$boundingClient;
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? defaultProps.color : _ref$color,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? defaultProps.spacing : _ref$spacing,
    backgroundImage = _ref.backgroundImage,
    id = _ref.id,
    hasSeparator = _ref.hasSeparator,
    hasOverflowHidden = _ref.hasOverflowHidden,
    isFillingRemainingSpace = _ref.isFillingRemainingSpace,
    hasFullscreenBackground = _ref.hasFullscreenBackground,
    hasHorizontalGradient = _ref.hasHorizontalGradient,
    otherSectionRefs = _ref.otherSectionRefs,
    customColor = _ref.customColor,
    zIndex = _ref.zIndex,
    isFullViewportHeight = _ref.isFullViewportHeight,
    viewportHeightOffsetUnit = _ref.viewportHeightOffsetUnit,
    isContentVerticalCenter = _ref.isContentVerticalCenter,
    link = _ref.link,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var isMediumOnly = useBreakpoint("medium", "large");
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    sectionsSumClientHeight = _useState2[0],
    setSectionsSumClientHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    topSpacingSpaceValue = _useState4[0],
    setTopSpacingSpaceValue = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    bottomSpacingSpaceValue = _useState6[0],
    setBottomSpacingSpaceValue = _useState6[1];
  var _useInView = useInView({
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView,
    entry = _useInView.entry;
  var $customColor = customColor ? getCustomColor(customColor.background) : undefined;
  var setSpacingSpaceValue = useCallback(function (setSpacingValue, spacingValue) {
    if (_typeof(spacingValue) === "object") {
      if (isSmallOnly) {
        setSpacingValue(spacingValue.small);
      } else if (isMediumOnly) {
        setSpacingValue(spacingValue.medium);
      } else {
        setSpacingValue(spacingValue.large);
      }
    } else {
      setSpacingValue(spacingValue);
    }
  }, [isSmallOnly, isMediumOnly]);
  var setTopAndBottomSpacingSpaceValue = useCallback(function () {
    if (_typeof(spacing) === "object" && "small" in spacing) {
      if (isSmallOnly) {
        setSpacingSpaceValue(setTopSpacingSpaceValue, spacingSpace[spacing.small.top]);
        setSpacingSpaceValue(setBottomSpacingSpaceValue, spacingSpace[spacing.small.bottom]);
      } else if (isMediumOnly) {
        setSpacingSpaceValue(setTopSpacingSpaceValue, spacingSpace[spacing.medium.top]);
        setSpacingSpaceValue(setBottomSpacingSpaceValue, spacingSpace[spacing.medium.bottom]);
      } else {
        setSpacingSpaceValue(setTopSpacingSpaceValue, spacingSpace[spacing.large.top]);
        setSpacingSpaceValue(setBottomSpacingSpaceValue, spacingSpace[spacing.large.bottom]);
      }
    } else if (_typeof(spacing) === "object") {
      setSpacingSpaceValue(setTopSpacingSpaceValue, spacingSpace[spacing.top]);
      setSpacingSpaceValue(setBottomSpacingSpaceValue, spacingSpace[spacing.bottom]);
    } else {
      var verticalSpacingSpace = spacingSpace[spacing];
      setSpacingSpaceValue(setTopSpacingSpaceValue, verticalSpacingSpace);
      setSpacingSpaceValue(setBottomSpacingSpaceValue, verticalSpacingSpace);
    }
  }, [spacing, isSmallOnly, isMediumOnly, setSpacingSpaceValue]);
  if (isFillingRemainingSpace && !otherSectionRefs) {
    throwError('"isFillingRemainingSpace" need sections ref pass by "otherSectionsRefs" props');
  }
  var handleSetSectionHeight = useCallback(function () {
    var sumClientHeight = 0;

    // eslint-disable-next-line no-unused-expressions
    otherSectionRefs === null || otherSectionRefs === void 0 || otherSectionRefs.forEach(function (sectionRef) {
      if (sectionRef && sectionRef.current) {
        sumClientHeight += sectionRef.current.clientHeight;
      }
    });
    setSectionsSumClientHeight(sumClientHeight);
  }, [otherSectionRefs]);
  useEffect(function () {
    setTopAndBottomSpacingSpaceValue();
  }, [setTopAndBottomSpacingSpaceValue]);
  useEffect(function () {
    handleSetSectionHeight();
    window.addEventListener("resize", handleSetSectionHeight);
    return function () {
      return window.removeEventListener("resize", handleSetSectionHeight);
    };
  }, [handleSetSectionHeight, sectionsSumClientHeight]);
  var $backgroundColor;
  if ((customColor === null || customColor === void 0 ? void 0 : customColor.text) === CustomTextColor.LIGHT) {
    $backgroundColor = "customDark";
  } else if ((customColor === null || customColor === void 0 ? void 0 : customColor.text) === CustomTextColor.DARK) {
    $backgroundColor = "customLight";
  }
  var sectionLink = link ? /*#__PURE__*/React.createElement(SectionLink, {
    to: link.to,
    href: link.href,
    title: link.title,
    openInNewTab: link.openInNewTab,
    onClick: link.onClick,
    rel: link.rel,
    "data-section-link": true
  }, link.text) : null;
  return /*#__PURE__*/React.createElement(StyledSectionOrg, _extends({
    id: id,
    ref: ref,
    $spacing: spacing,
    $color: color,
    $customColor: $customColor,
    $backgroundImage: backgroundImage,
    $isInView: inView,
    $height: (_entry$boundingClient = entry === null || entry === void 0 ? void 0 : entry.boundingClientRect.height) !== null && _entry$boundingClient !== void 0 ? _entry$boundingClient : 0,
    $hasSeparator: !!hasSeparator,
    $hasOverflowHidden: !!hasOverflowHidden,
    $isFillingRemainingSpace: !!isFillingRemainingSpace,
    $hasHorizontalGradient: !!hasHorizontalGradient,
    $sectionsSumClientHeight: sectionsSumClientHeight,
    $zIndex: zIndex,
    $isFullViewportHeight: !!isFullViewportHeight,
    $viewportHeightOffsetUnit: viewportHeightOffsetUnit || headerHeight,
    $isContentVerticalCenter: !!isContentVerticalCenter
  }, restProps), hasFullscreenBackground ? /*#__PURE__*/React.createElement(FullscreenBackground, {
    $color: color
  }) : null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: $backgroundColor || backgrounds[color]
  }, /*#__PURE__*/React.createElement(SectionSpacingValueSpaceContext.Provider, {
    value: useMemo(function () {
      return {
        top: topSpacingSpaceValue,
        bottom: bottomSpacingSpaceValue
      };
    }, [topSpacingSpaceValue, bottomSpacingSpaceValue])
  }, children, sectionLink)));
}
export default SectionOrg;